import React, { FormEvent, useState } from 'react';
import { authAPI } from '../../utils/api';
import { useAuth } from '../../contexts/AuthContext';
import '../../pages/Login/Login.css';
import './EmailVerification.css';

const EmailVerification: React.FC = () => {
  const { user, refreshUser, logout } = useAuth();
  const [code, setCode] = useState('');
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [resendAt, setResendAt] = useState(0);
  const send = async () => {
    if (busy) return;
    setBusy(true); setError('');
    try { await authAPI.sendEmailCode(); setSent(true); setResendAt(Date.now() + 60000); }
    catch (e) { setError(e instanceof Error ? e.message : 'Не удалось отправить код'); }
    finally { setBusy(false); }
  };
  const verify = async (event: FormEvent) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError('');
    try { await authAPI.verifyEmail(code); await refreshUser(); }
    catch (e) { setError(e instanceof Error ? e.message : 'Не удалось подтвердить почту'); }
    finally { setBusy(false); }
  };
  return <main className="login-container"><section className="login-modal email-verification" aria-labelledby="verify-email-title">
    <h1 className="login-title" id="verify-email-title">Подтвердите почту</h1>
    <p className="login-subtitle">Чтобы продолжить пользоваться кабинетом, подтвердите адрес <strong>{user?.email}</strong>. Ваши камеры и данные сохранены.</p>
    {error && <p className="ui-alert ui-alert--danger" role="alert">{error}</p>}
    {!sent ? <button className="ui-btn ui-btn--primary" disabled={busy} onClick={() => void send()}>{busy ? 'Отправка…' : 'Отправить код на почту'}</button> : <form onSubmit={verify}>
      <p className="login-subtitle">Код отправлен. Он действует 10 минут. Если письма нет, проверьте папку «Спам».</p>
      <label>Код из письма<input className="ui-input" style={{ width: '100%', margin: '8px 0 16px' }} aria-label="Код из письма" value={code} onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))} inputMode="numeric" autoComplete="one-time-code" maxLength={6} required /></label>
      <button className="ui-btn ui-btn--primary" type="submit" disabled={busy || code.length !== 6}>{busy ? 'Проверка…' : 'Подтвердить почту'}</button>
      <button className="ui-btn ui-btn--outline" type="button" disabled={busy} onClick={() => { if (Date.now() < resendAt) { setError('Повторный код можно отправить через минуту.'); return; } void send(); }}>Отправить код повторно</button>
    </form>}
    <div className="email-verification__logout"><button type="button" className="ui-btn ui-btn--outline" disabled={busy} onClick={() => void logout()}>Выйти из аккаунта</button></div>
  </section></main>;
};
export default EmailVerification;
